import React from "react";
import { FormattedNumber } from "react-intl";

interface Props {
    value: number;
    label: React.ReactNode;
    totalCount?: number;
    isPercentage?: boolean;
    title?: string;
}

interface PercentageStatProps {
    value?: number;
    pc: number;
}

const PercentageStat = ({ value, pc }: PercentageStatProps) => (
    <>
        <div className="headline-stat__bar">
            <span style={{width: (pc * 100) + "%"}} />
        </div>
        {value != null && (
            <span className="headline-stat__compact">
                <FormattedNumber
                    value={value}
                    notation="compact"
                    compactDisplay="short"
                    maximumFractionDigits={0}
                />
            </span>
        )}
    </>
);

const HeadlineStat = ({ value, totalCount, label, isPercentage, title }: Props) => (
    <div className="headline-stat" title={title}>
        <small className="headline-stat__label">{label}</small>
        <span className="headline-stat__value display-3">
            {value != null &&
                <FormattedNumber
                    value={
                        totalCount != null && totalCount > 0 && isPercentage
                            ? value / totalCount
                            : (totalCount != null ? totalCount : value)
                    }
                    style={isPercentage ? "percent" : undefined}
                    maximumFractionDigits={1}
                />
            }
            {value == null && "-"}
        </span>
        {isPercentage && totalCount == null && (
            <PercentageStat pc={value} />
        )}
        {(
            (isPercentage && totalCount != null)
            || (!isPercentage && totalCount != null && value < totalCount)
         ) && (
            <PercentageStat value={value} pc={value / totalCount} />
        )}
    </div>
);

export {
    PercentageStat,
    HeadlineStat,
    Props as HeadlineStats,
};
